function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  stroke: "none",
  cx: 6,
  cy: 50,
  r: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  dur: "1s",
  values: "0;1;0",
  repeatCount: "indefinite",
  begin: 0.1
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  stroke: "none",
  cx: 26,
  cy: 50,
  r: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  dur: "1s",
  values: "0;1;0",
  repeatCount: "indefinite",
  begin: 0.2
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  stroke: "none",
  cx: 46,
  cy: 50,
  r: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  dur: "1s",
  values: "0;1;0",
  repeatCount: "indefinite",
  begin: 0.3
}));

const SvgSpinner = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 52 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpinner, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/spinner.cdd9b39a.svg";
export { ForwardRef as ReactComponent };